export default __webpack_public_path__ + "static/img-map-satellite-190dc9ea9dd0f7d7e0fd976506287c1b.jpg";